<template>
    <div class="text-center">
        <cmui-popup class="award_list" :visible.sync="showAward" position="center"
                    :stop-page-scroll="true"
                    :mask-event="true">
            <div>
                <div class="text-center pos-r"
                     style="padding-bottom: 160px;padding-top: 45px;width: 320px;min-height: 256px;background: url('//image1.51tiangou.com/tgou2/img2/coupon/bg-pay_01.png') no-repeat bottom center; background-size: 100% auto;margin-top: -45px;">
                    <div style="top: 0px;width: 256px;margin-left: 32px;">
                        <div v-if="award.awardType !== 'Thanks'" class="border-radius">
                            <img src="//image1.51tiangou.com/tgou2/img2/coupon/title-pay_01.png" alt="" width="256">
                        </div>
                        <!--                        没中奖-->
                        <div class="award_list_contant marginv20" v-if="award.awardType === 'Thanks'">
                            <img src="//image1.51tiangou.com/tgou2/img2/coupon/blank-pay_noZhong.png" alt="">
                        </div>

                        <div class="overflow-yh bg-white" style="max-height:250px;" v-if="award.awardType !== 'Thanks'">
                            <!--                            狗粮-->
                            <div class="award_list_contant marginv20" style="width: 256px;"
                                 v-if="award.awardType === 'Point'">
                                <div class="pos-r">
                                    <img src="//image1.51tiangou.com/tgou2/img2/coupon/img-pay_02.png?id=21" alt=""
                                         width="157">
                                    <div class="pos-a fs-11 left0 right0" style="bottom: 15px;color: #ff8a88">
                                        <img src="//image1.51tiangou.com/tgou2/img2/coupon/icon-pay_02.png!y" alt="" width="12px;">
                                        <span>狗粮</span><span style="font-size: 24px;" v-text="dogAwardName(award.awardName)"></span><span>份</span>
                                    </div>
                                </div>
                            </div>
                            <!--                            优惠券 或者 链接-->
                            <div class="award_list_contant marginv20 flex-container-col center"
                                 v-if="award.awardType === 'StoreCoupon' || award.awardType === 'MaterialCoupon' || award.awardType === 'CrossCoupon'|| award.awardType === 'Coupon'  || award.awardType === 'UrlAward'">
                                <tg-coupon-simple :coupon="localAward" coupon-list-type="award"></tg-coupon-simple>
                            </div>
                        </div>

                    </div>
                    <div class="flex-container-col pos-a left0 right0" style="bottom: 44px;font-weight: bold"
                         v-if="award.awardType === 'StoreCoupon' || award.awardType === 'MaterialCoupon' || award.awardType === 'CrossCoupon'|| award.awardType === 'Coupon'">
                        <span class="fs-14 text-white"><span>该券(共</span><span>{{award.coupons.length}}</span><span>张)已直接放入您的券包中,请查看</span></span>
                        <a href="/coupon/index.html"><div class="bag text-red fs-16 lh-40 margint40" style="font-weight: bold">去卡包看看</div></a>
                    </div>
                    <div class="flex-container-col pos-a left0 right0" style="bottom: 64px;"
                         v-if="award.awardType === 'Point'  || award.awardType === 'UrlAward'">
                        <a :href="award.url">
                            <div class="bag text-red fs-16 lh-40" style="font-weight: bold">去看看</div>
                        </a>
                    </div>
                    <div class="flex-container-col pos-a left0 right0" style="bottom: 64px;" v-if="award.awardType === 'Thanks'">
                        <img src="//image1.51tiangou.com/tgou2/img2/coupon/icon-pay_money.png" alt="" width="44">
                    </div>
                </div>
            </div>
            <div class="flex-container-col pos-a left0 right0 margint20" style="font-size: 24px">
                <i class="icon-roundclosefill text-white" @click="showAward = false"></i>
            </div>
        </cmui-popup>

    </div>
</template>

<script>
    import "javascript/libs/tg/component/couponNew/index.js";
    export default {
        data() {
        },
        props: {
            id: {
                type: String,
                default: 'card'
            },
            award: {
                type: Object,
                default: {}
            },
            showAward: {
                type: Boolean,
                default: true
            }
        },
        ready() {
        },
        computed: {
            localAward() {
                let tempArr = [];
                if (this.award && this.award.coupons){
                    this.award.coupons.map(function (coupon) {
                        // 点击链接
                        coupon.clickUrl = coupon.useUrl;
                        //券类型
                        const COUPON_TYPE = {
                            CASH: 1,         //现金券
                            DISCOUNT: 2,     //折扣券
                            REDUCE: 3,       //满减券
                            GIFT: 4,         //买送券
                            PARK: 8,         //停车券
                            FRESH: 9,        //礼品券（保鲜礼）
                            NEW_CASH: 10,    //抵值券
                            NEW_DISCOUNT: 11, //新折扣券
                            NEW_GIFT: 14,     //新礼品券
                            Shipping: 15,     //运费券
                            Gold: 16,          //黄金券,
                            Ship_REDUCE: 17    //运费满减
                        };
                        let promotionRule = coupon.promotionRule && JSON.parse(coupon.promotionRule) || {};
                        if (coupon.type === COUPON_TYPE.CASH || coupon.type === COUPON_TYPE.Shipping) {
                            //现金券 和 运费券
                            coupon.subTitle = {
                                symbol: '¥',
                                main: promotionRule.cash + 0
                            };
                        } else if (coupon.type === COUPON_TYPE.DISCOUNT || coupon.type === COUPON_TYPE.NEW_DISCOUNT) {
                            //折扣券
                            coupon.subTitle ={
                                main: promotionRule.discount + 0,
                                desc: '折'
                            };
                        } else if (coupon.type === COUPON_TYPE.REDUCE || coupon.type === COUPON_TYPE.NEW_CASH) {
                            //满减券 或 抵值券
                            coupon.subTitle = {
                                main: promotionRule.minus + 0,
                                desc: '元'
                            };
                        } else if (coupon.type === COUPON_TYPE.GIFT) {
                            //满送券
                            coupon.subTitle = {
                                main: '赠品'
                            };
                        } else if (coupon.type === COUPON_TYPE.NEW_GIFT) {
                            //礼品券
                            coupon.subTitle = {
                                main: '礼品'
                            };
                        } else if (coupon.type === COUPON_TYPE.PARK) {
                            coupon.subTitle = {
                                main: promotionRule.cash + 0,
                                desc: '元'
                            };
                        } else if (coupon.type === COUPON_TYPE.Gold) {
                            coupon.subTitle = {
                                symbol: '¥',
                                main: promotionRule.everyDiscount  + 0
                            };
                        } else if (coupon.type === COUPON_TYPE.Ship_REDUCE) {
                            //运费满减券
                            coupon.subTitle = {
                                symbol: '￥',
                                main: promotionRule.minus + 0
                            } ;
                        }
                        // 券限制
                        if((coupon.type === COUPON_TYPE.REDUCE || coupon.type === COUPON_TYPE.Ship_REDUCE) && promotionRule){
                            //满减券
                            coupon.limitStr = '满' + promotionRule.full + '元使用';
                        }else if (coupon.type === COUPON_TYPE.Shipping){
                            coupon.limitStr = '无金额门槛';
                        }else if (coupon.type === COUPON_TYPE.Gold){
                            coupon.limitStr = '每克减';
                        } else{
                            coupon.limitStr = '';
                        }
                        tempArr.push(coupon)
                    })
                }

                if (this.award.awardType === "UrlAward"){
                    tempArr.push({
                        name:this.award.awardName,
                        awaUrl:this.award.url
                    })
                }
                return tempArr;
            }

        },
        methods: {
            dogAwardName:function (name) {
                return name.replace(/[^0-9]/ig,"");
            }
        }
    }
</script>

<style lang="scss">
    .bg-award {
        background: url("//image1.51tiangou.com/tgou2/img2/coupon/bg-pay_coupon.png") no-repeat bottom center;
        background-size: 100% 100%;
    }

    .award_list .cmui-popup__content {
        background-color: transparent;
    }

    .bag {
        background: #FFF7CD;
        border-radius: 20px;
        width: 146px;
    }

    /*.couponsList1 {*/
    /*    min-height: 60px !important;*/
    /*    width: 157px !important;*/
    /*}*/

    .cmui-popup__mask {
        background-color: rgba(0, 0, 0, 0.6) !important;
    }
</style>
